<!-- #29 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Carrier Pickup Slot
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card class="mt-2">
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ $route.params.id == 0 ? "Add" : "Edit" }}

          <i class="caption red--text ml-4"> * required field</i>
        </span>
        <v-spacer></v-spacer>
        <span class="caption" style="color: green">
          Note: Pickup Slot Date Time is based on Pickup Address Country</span
        >
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-autocomplete
                v-model="carrier_id"
                label="Select Carrier"
                class="pt-0 pb-0 required"
                item-text="name"
                item-value="id"
                :items="carriersList"
                hide-details="auto"
                outlined
                @focus="fetchCarriers()"
                @change="getCountryList(carrier_id)"
                :rules="[(v) => !!v || 'Carrier is required.']"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="country_id"
                :items="countries"
                label="Select Country"
                placeholder="Start typing to Search"
                item-text="country_name"
                item-value="country_id"
                outlined
                small-chips
                class="required"
                :rules="[(v) => !!v || 'Country is required.']"
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="slot_type"
                :items="slots_types"
                outlined
                label="Slot Type"
                item-text="text"
                hide-details="auto"
                :rules="[(v) => !!v || 'Slot Type is required.']"
                item-value="value"
                class="required"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" v-if="slot_type == 'standard'">
              <v-autocomplete
                v-if="$route.params.id == 0"
                v-model="selectedWeekdays"
                :items="weekdays"
                outlined
                label="Week Days"
                multiple
                hide-details="auto"
                class="required"
                small-chips
                :rules="[(v) => (v || []).length > 0 || 'Weekday is required.']"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                v-model="selectedWeekday"
                :items="weekdays"
                outlined
                label="Week Days"
                hide-details="auto"
                class="required"
                :rules="[(v) => !!v || 'Weekday is required.']"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              v-if="
                (slot_type == 'public_holiday' || slot_type == 'customized') &&
                $route.params.id == 0
              "
            >
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="Start Schedule Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                    class="required"
                    :rules="[(v) => !!v || 'Start Schedule Date is required.']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                  :min="getStartDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              v-if="
                (slot_type == 'public_holiday' || slot_type == 'customized') &&
                $route.params.id == 0
              "
            >
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                hide-details="auto"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="End Schedule Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                    class="required"
                    :rules="[(v) => !!v || 'End Schedule Date is required.']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                  :min="getStartDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              v-if="
                (slot_type == 'public_holiday' || slot_type == 'customized') &&
                $route.params.id > 0
              "
            >
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                hide-details="auto"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="Schedule Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    clearable
                    outlined
                    class="required"
                    :rules="[(v) => !!v || 'Schedule Date is required.']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                  :min="getStartDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              v-if="slot_type == 'standard' || slot_type == 'customized'"
            >
              <v-menu
                v-model="menuTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="start_slot_time"
                    label="Start Slot Time"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                    class="required"
                    :rules="[(v) => !!v || 'Start Slot Time is required.']"
                  ></v-text-field>
                </template>

                <v-time-picker
                  v-model="start_slot_time"
                  format="24hr"
                  min="06:00"
                  max="21:00"
                  @change="menuTime = false"
                  style="width: 100%"
                  outlined
                ></v-time-picker>
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              sm="4"
              v-if="slot_type == 'standard' || slot_type == 'customized'"
            >
              <v-menu
                v-model="menuTimeTo"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="end_slot_time"
                    label="End Slot Time"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                    class="required"
                    :rules="[(v) => !!v || 'End Slot Time is required.']"
                  ></v-text-field>
                </template>

                <v-time-picker
                  v-model="end_slot_time"
                  @change="menuTimeTo = false"
                  style="width: 100%"
                  outlined
                  format="24hr"
                  min="07:00"
                  max="22:00"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4" v-if="slot_type == 'customized'">
              <v-autocomplete
                v-model="exclude_weekdays_flag"
                :items="flags"
                hide-no-data
                item-text="text"
                item-value="value"
                class="required"
                label="Exclude Weekdays Flag"
                :rules="[
                  (v) =>
                    (v !== null && v !== undefined && v !== '') ||
                    'Weekdays Flag is required.',
                ]"
                outlined
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              v-if="slot_type == 'customized' && exclude_weekdays_flag == 1"
            >
              <v-autocomplete
                v-model="exclude_weekdays"
                :items="weeks"
                hide-no-data
                item-text="text"
                item-value="value"
                class="required"
                label="Exclude Weekdays"
                :rules="[
                  (v) =>
                    (v !== null &&
                      v !== undefined &&
                      v !== '' &&
                      v.length > 0) ||
                    'Exclude Weekdays is required.',
                ]"
                outlined
                hide-details="auto"
                multiple
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="status"
                :items="statuses"
                hide-no-data
                item-text="text"
                item-value="value"
                class="required"
                label="Select Status"
                :rules="[
                  (v) =>
                    (v !== null && v !== undefined && v !== '') ||
                    'Status is required.',
                ]"
                outlined
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-btn
            color="primary"
            @click="save()"
            :loading="saveLoader"
            dark
            v-if="$route.params.id > 0"
            class="mt-5"
          >
            Update
          </v-btn>
          <v-btn
            color="primary"
            @click="save()"
            :loading="saveLoader"
            dark
            class="mt-5"
            v-else
          >
            save
          </v-btn>
          <v-btn
            class="ml-3 mt-4"
            color="white"
            @click="$router.push('/pickup-auto')"
          >
            Cancel
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
    <email
      v-if="carrier_id"
      :carrierId="carrier_id"
      :countryId="country_id"
      :isPickup="true"
      :key="carrier_id + '-' + country_id"
    />
  </v-col>
</template>

<script>
import { mapActions } from "vuex";
import email from "./email.vue";
export default {
  components: { email },
  computed: {
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },
  },
  data() {
    return {
      exclude_weekdays_flag: null,
      exclude_weekdays: [],
      selectedWeekday: null,
      start_slot_time: null,
      end_slot_time: null,
      options: {},
      carrier_id: null,
      city_id: null,
      country_id: null,
      activeCarriersListTypes: [],
      zipcode: null,
      slot_type: "",
      status: "",
      from_date: "",
      to_date: "",
      menuTime: false,
      menuTimeTo: false,
      dateMenu: false,
      dateMenuTo: false,
      statuses: [
        {
          text: "Active",
          value: 1,
        },
        {
          text: "InActive",
          value: 0,
        },
        {
          text: "Excluded",
          value: 3,
          disabled: true,
        },
      ],

      flags: [
        {
          text: "Yes",
          value: 1,
        },
        {
          text: "No",
          value: 0,
        },
      ],
      slots_types: [
        {
          text: "Standard",
          value: "standard",
        },
        {
          text: "Public Holiday",
          value: "public_holiday",
        },
        {
          text: "Customized",
          value: "customized",
        },
      ],
      selectedWeekdays: [],
      weekdays: [
        {
          text: "Monday",
        },
        {
          text: "Tuesday",
        },
        {
          text: "Wednesday",
        },
        {
          text: "Thursday",
        },
        {
          text: "Friday",
        },
        {
          text: "Saturday",
        },
        {
          text: "Sunday",
        },
      ],
      weeks: [
        {
          text: "Saturday",
          value: 5,
        },
        {
          text: "Sunday",
          value: 6,
        },
        {
          text: "Monday",
          value: 0,
        },
        {
          text: "Tuesday",
          value: 1,
        },
        {
          text: "Wednesday",
          value: 2,
        },
        {
          text: "Thursday",
          value: 3,
        },
        {
          text: "Friday",
          value: 4,
        },
      ],
      slotList: [],
      editedIndex: -1,
      loader: false,
      statusLoader: false,
      active: "",
      name: "",
      filtersArr: {},
      carrierForm: false,
      carrierDetail: {},
      saveLoader: false,
      addList: {},
      total: 0,
      countries: [],
      cityLoader: false,
      cities: [],
      timeSlots: [],
      carriersList: [],
      schedule_date: null,
    };
  },
  async created() {
    await this.fetchCarriers();
    if (this.$route.params.id > 0) {
      this.callApi(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions([
      "addPickupSlot",
      "getCarriersDropdown",
      "getTypeClients",
      "snackBar",
      "getPickupCountries",
      "getInforWarehouseList",
      "updateSlot",
      "getSlotRecord",
    ]),
    isItemDisabled(item) {
      return item.value === 3; // Disable "Extended" status
    },
    getCountryList(id) {
      this.country_id = null;
      this.countries = [];
      if (id) {
        this.getPickupCountries(id).then((res) => {
          this.countries = res.data;
        });
      }
    },
    async fetchCarriers() {
      await this.getCarriersDropdown({
        pagination: 0,
        active: "all",
      })
        .then((res) => {
          this.carriersList = res.data.filter(
            (carrier) => carrier.active === true
          );
        })
        .catch(() => {
          this.loader = false;
        });
    },

    callApi(id) {
      this.getSlotRecord(id).then(async (res) => {
        this.carrier_id = res.data.records[0].carrier_id;
        await this.getCountryList(this.carrier_id);
        this.status = res.data.records[0].status;
        this.slot_type = res.data.records[0].slot_type;
        this.selectedWeekday = res.data.records[0].weekday;
        this.to_date = res.data.records[0].schedule_date;
        this.country_id = res.data.records[0].country_id;
        this.start_slot_time = res.data.records[0].start_slot_time;
        this.end_slot_time = res.data.records[0].end_slot_time;
        this.exclude_weekdays_flag =
          res.data.records[0].exclude_weekdays_flag == false ? 0 : 1;
        this.exclude_weekdays = res.data.records[0].excluded_weekdays;
      });
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      var obj = {};
      if (this.exclude_weekdays_flag == 0) {
        this.exclude_weekdays = [];
      }
      if (this.carrier_id) obj.carrier_id = this.carrier_id;
      if (this.country_id) obj.country_id = this.country_id;
      if (this.slot_type) obj.slot_type = this.slot_type;
      if (this.from_date) obj.start_schedule_date = this.from_date;
      if (this.to_date) obj.end_schedule_date = this.to_date;
      if (this.start_slot_time) obj.start_slot_time = this.start_slot_time;
      if (this.end_slot_time) obj.end_slot_time = this.end_slot_time;
      obj.status = this.status;
      if (this.selectedWeekdays.length > 0)
        obj.weekdays = this.selectedWeekdays;

      obj.exclude_weekdays_flag = this.exclude_weekdays_flag;
      if (this.exclude_weekdays) obj.excluded_weekdays = this.exclude_weekdays;

      this.saveLoader = true;
      if (this.$route.params.id > 0) {
        if (this.to_date) obj.end_schedule_date = this.to_date;
        if (this.to_date) obj.start_schedule_date = this.to_date;

        if (this.selectedWeekday) obj.weekdays = this.selectedWeekday;
        let data = {
          data: obj,
          id: this.$route.params.id,
        };
        this.updateSlot(data)
          .then((res) => {
            this.saveLoader = false;
            this.$router.replace({
              name: "PickupAuto",
            });
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
          })
          .catch(() => {
            this.saveLoader = false;
          });
      } else {
        this.addPickupSlot(obj)
          .then((res) => {
            this.saveLoader = false;
            this.$router.replace({
              name: "PickupAuto",
            });
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
  },
};
</script>
